import { computed, type ComputedRef } from 'vue';

export type UseSelectAllParams<T> = {
  options: () => T[];
  selected: () => T[];
  isSelected: (option: T) => boolean;
  isDisabled?: (option: T) => boolean;
};

export type UseSelectAll<T> = {
  allSelected: ComputedRef<boolean>;
  someSelected: ComputedRef<boolean>;
  selectableOptions: ComputedRef<T[]>;
};

export const useSelectAll = <T>({
  options,
  selected,
  isSelected,
  isDisabled,
}: UseSelectAllParams<T>): UseSelectAll<T> => {
  const selectableOptions = computed(() =>
    isDisabled ? options().filter((option) => !isDisabled(option)) : options(),
  );

  const allSelected = computed(
    () =>
      selectableOptions.value.length > 0 &&
      selectableOptions.value.every((option) => isSelected(option)),
  );

  const someSelected = computed(
    () => selected().length > 0 && !allSelected.value,
  );

  return { allSelected, someSelected, selectableOptions };
};
